import { render, staticRenderFns } from "./BriefIcon.vue?vue&type=template&id=629ba28a&scoped=true"
import script from "./BriefIcon.vue?vue&type=script&lang=js"
export * from "./BriefIcon.vue?vue&type=script&lang=js"
import style0 from "./BriefIcon.vue?vue&type=style&index=0&id=629ba28a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629ba28a",
  null
  
)

export default component.exports